import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FileTextIcon, CheckIcon, AlertTriangleIcon, GiftIcon } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
export const FreeTipsSection: React.FC = () => {
  const [isRedirecting, setIsRedirecting] = useState(false);
  const navigate = useNavigate();
  const handleFreeTipsClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    navigate('/rady');
  };
  return <section className="py-12 md:py-20 section section-dark overflow-hidden relative" data-id="element-508">
      <div className="container mx-auto px-4 relative" data-id="element-509">
        {/* Ambient background glow */}
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-3xl h-64 bg-green-500/10 blur-[100px] rounded-full pointer-events-none" data-id="element-510" />

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="relative max-w-4xl mx-auto" data-id="element-511">
          {/* Gradient Border Wrapper */}
          <div className="absolute -inset-[1px] bg-gradient-to-br from-green-300/40 via-green-600/20 to-green-900/40 rounded-2xl blur-[1px]" data-id="element-512" />

          <div className="relative bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 rounded-2xl p-6 sm:p-8 md:p-12 flex flex-col md:flex-row items-center gap-6 md:gap-16 shadow-2xl shadow-green-900/10 border border-white/5" data-id="element-513">
            {/* Left side - Premium Icon */}
            <div className="flex-shrink-0 relative group transform scale-90 md:scale-100" data-id="element-514">
              <div className="absolute inset-0 bg-green-500/20 blur-xl rounded-full group-hover:bg-green-500/30 transition-all duration-500" data-id="element-515" />
              <div className="relative w-28 h-28 md:w-32 md:h-32 rounded-full flex items-center justify-center bg-gradient-to-br from-gray-800 to-gray-900 border border-green-500/30 shadow-inner shadow-green-500/10" data-id="element-516">
                <FileTextIcon className="w-12 h-12 md:w-14 md:h-14 text-green-400 drop-shadow-[0_0_10px_rgba(74,222,128,0.3)]" strokeWidth={1.5} data-id="element-517" />
              </div>
              <div className="absolute -bottom-3 left-1/2 transform -translate-x-1/2 bg-gradient-to-r from-green-600 to-green-500 text-black text-[10px] tracking-widest font-bold px-4 py-1.5 rounded-full shadow-lg shadow-green-900/50 uppercase border border-green-400/50" data-id="element-518">
                Zdarma
              </div>
            </div>

            {/* Right side - Content */}
            <div className="flex-1 text-center md:text-left" data-id="element-519">
              <h2 className="text-xl sm:text-2xl md:text-3xl font-bold mb-4 md:mb-6 tracking-tight" data-id="element-520">
                <span className="bg-clip-text text-transparent bg-gradient-to-r from-green-200 via-green-400 to-green-600 drop-shadow-sm" data-id="element-521">
                  ZÍSKEJ ZDARMA
                </span>{' '}
                <span className="text-white block mt-1" data-id="element-522">
                  TIPY PRO RYCHLEJŠÍ PROGRESS
                </span>
              </h2>

              <p className="text-slate-400 mb-6 md:mb-8 leading-relaxed font-light text-sm sm:text-base md:text-lg" data-id="element-523">
                Chceš se dozvědět tajemství, která mohou dramaticky zrychlit
                tvůj progress? Připravil jsem PDF plné tipů a rad, které ti
                pomohou posunout tvůj trénink a výsledky na další úroveň.
              </p>

              <div className="space-y-3 md:space-y-4 mb-8 md:mb-10 text-left" data-id="element-524">
                <div className="flex items-start gap-3 md:gap-4 text-slate-300 group" data-id="element-525">
                  <div className="p-1 rounded-full bg-green-500/10 border border-green-500/20 mt-0.5 group-hover:border-green-500/40 transition-colors flex-shrink-0" data-id="element-526">
                    <CheckIcon className="w-3.5 h-3.5 md:w-4 md:h-4 text-green-400" data-id="element-527" />
                  </div>
                  <span className="font-light text-sm sm:text-base" data-id="element-528">
                    Tajné tipy pro maximální efektivitu tréninku
                  </span>
                </div>
                <div className="flex items-start gap-3 md:gap-4 text-slate-300 group" data-id="element-529">
                  <div className="p-1 rounded-full bg-green-500/10 border border-green-500/20 mt-0.5 group-hover:border-green-500/40 transition-colors flex-shrink-0" data-id="element-530">
                    <AlertTriangleIcon className="w-3.5 h-3.5 md:w-4 md:h-4 text-green-500" data-id="element-531" />
                  </div>
                  <span className="font-light text-sm sm:text-base" data-id="element-532">
                    Nejčastější chyby, které brzdí tvůj progress
                  </span>
                </div>
                <div className="flex items-start gap-3 md:gap-4 text-slate-300 group" data-id="element-533">
                  <div className="p-1 rounded-full bg-green-500/10 border border-green-500/20 mt-0.5 group-hover:border-green-500/40 transition-colors flex-shrink-0" data-id="element-534">
                    <GiftIcon className="w-3.5 h-3.5 md:w-4 md:h-4 text-green-400" data-id="element-535" />
                  </div>
                  <span className="font-light text-sm sm:text-base" data-id="element-536">
                    2 bonusové rady které mně pomohly s rapidním růstem
                  </span>
                </div>
              </div>

              <motion.button onClick={handleFreeTipsClick} disabled={isRedirecting} whileHover={{
              scale: isRedirecting ? 1 : 1.02,
              boxShadow: isRedirecting ? undefined : '0 20px 40px -10px rgba(34, 197, 94, 0.3)'
            }} whileTap={{
              scale: isRedirecting ? 1 : 0.98
            }} className="w-full md:w-auto relative group overflow-hidden bg-gradient-to-r from-green-600 via-green-500 to-green-600 bg-[length:200%_auto] hover:bg-[position:right_center] text-black font-bold py-3 md:py-4 px-8 md:px-10 rounded-xl transition-all duration-500 shadow-xl shadow-green-900/20 border border-green-400/50 disabled:opacity-100 disabled:cursor-default" data-id="element-537">
                <span className="relative z-10 tracking-wider text-sm md:text-base" data-id="element-538">
                  {isRedirecting ? 'PŘESMĚROVÁVÁM...' : 'MÁM ZÁJEM!'}
                </span>
                <div className="absolute inset-0 bg-white/20 translate-y-full group-hover:translate-y-0 transition-transform duration-500 skew-y-12" data-id="element-539" />
              </motion.button>
            </div>
          </div>
        </motion.div>
      </div>

      {/* Redirecting Overlay */}
      <AnimatePresence data-id="element-540">
        {isRedirecting && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} className="fixed inset-0 bg-black/95 backdrop-blur-sm z-50 flex items-center justify-center" data-id="element-541">
            <motion.div initial={{
          scale: 0.9,
          opacity: 0
        }} animate={{
          scale: 1,
          opacity: 1
        }} transition={{
          delay: 0.1
        }} className="text-center" data-id="element-542">
              <div className="mb-6" data-id="element-543">
                <motion.div animate={{
              rotate: 360
            }} transition={{
              duration: 1,
              repeat: Infinity,
              ease: 'linear'
            }} className="w-16 h-16 border-4 border-green-500 border-t-transparent rounded-full mx-auto" data-id="element-544" />
              </div>
              <h3 className="text-2xl font-bold text-white mb-2" data-id="element-545">
                Přesměrovávám na tipy zdarma...
              </h3>
              <p className="text-gray-400" data-id="element-546">Moment prosím</p>
            </motion.div>
          </motion.div>}
      </AnimatePresence>
    </section>;
};